// extracted by mini-css-extract-plugin
export var footLine = "br10-_";
export var footTop = "br10-X";
export var footTopAddress = "br10--";
export var footTopDesc = "br10-Y";
export var footTopText = "br10-Z";
export var footerM = "br10-W";
export var footerNavItem = "br10-1";
export var footerNavs = "br10-0";
export var minWidthLimit = "br10-V";